{
  "emptyState": "Sin aprobaciones FAA pendientes",
  "unknown": "Desconoc.",
  "headers": {
    "tailNumber": "Matrícula",
    "aircraftType": "Tipo de aeronave",
    "fbo": "FBO",
    "submittedBy": "Enviado por",
    "submitted": "Enviado",
    "tenant": "Inquilino",
    "actions": "Acciones"
  },
  "tenant": {
    "created": "Creado",
    "noTenant": "Sin tenant"
  },
  "errors": {
    "missingData": "No se puede aprobar: faltan datos de la aeronave. Intenta actualizar.",
    "createFaaTail": "No se pudo crear la entrada de matrícula FAA: {{message}}",
    "createFaaMapping": "No se pudo crear el mapeo FAA: {{message}}",
    "markApproved": "No se pudo marcar como aprobado: {{message}}",
    "approveFailed": "No se pudo aprobar. Intenta de nuevo.",
    "rejectFailed": "No se pudo rechazar. Intenta de nuevo."
  },
  "success": {
    "approved": "Mapeo FAA aprobado para {{tailNumber}} → {{make}} {{model}}",
    "rejected": "Solicitud de aprobación rechazada para {{tailNumber}}"
  }
}
